import { contains, isEmpty } from "../../fable_modules/fable-library.3.7.20/List.js";
import { uncurry, safeHash, equals } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { Filter } from "./Model.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy } from "../../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { string_type, equals as equals_1 } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { SearchResultV2$reflection } from "../../CommonTypes.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { ValidatedUrlModule_value, addClientReference, Http_get_ExtraCoders } from "../../HttpV2.js";
import { Http_request, Http_method, Http_withCredentials, Http_send } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { HttpMethod } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";

export function loadSearchResultsV2(clientNr, searchText, filters, searchFrom, searchTo) {
    let arg_6, arg_5, arg_4, arg_3, arg_2;
    const filterText = (f, str) => {
        if (isEmpty(filters)) {
            return "";
        }
        else if (!contains(f, filters, {
            Equals: equals,
            GetHashCode: safeHash,
        })) {
            return ("\u0026" + str) + "=false";
        }
        else {
            return "";
        }
    };
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, (arg_6 = filterText(new Filter(4), "filterIncludeNoContracts"), (arg_5 = filterText(new Filter(1), "filterIncludeActiveWithEndDate"), (arg_4 = filterText(new Filter(0), "filterIncludeActive"), (arg_3 = filterText(new Filter(2), "filterIncludeCancelled"), (arg_2 = filterText(new Filter(3), "filterIncludePending"), toText(printf("/Invoicee/Search/%i?q=%s%s%s%s%s%s\u0026from=%i\u0026to=%i"))(clientNr)(searchText)(arg_2)(arg_3)(arg_4)(arg_5)(arg_6)(searchFrom)(searchTo))))))));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_9 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str_1 = arg_1_1;
            return equals_1(SearchResultV2$reflection(), string_type) ? (new FSharpResult$2(0, str_1)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(SearchResultV2$reflection(), arg_9, Http_get_ExtraCoders().Value)), str_1);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals_1(SearchResultV2$reflection(), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

